var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',_vm._g({class:[_vm.b(), ("om-icon-" + _vm.name)]},_vm.listeners),[_vm._t("default"),_vm._v(" "),(_vm.isDef(_vm.info))?_c('div',{class:_vm.b('info')},[_vm._v(_vm._s(_vm.info))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cdaabee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/jscom/omui/components/icon/index.vue
// module id = 4Frs
// module chunks = 76